
import React from 'react';
import { Card } from '@/components/ui/card';
import { ChartContainer } from '@/components/ui/chart';
import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from 'recharts';

interface ReferralActivityChartProps {
  chartData: any[];
}

const ReferralActivityChart: React.FC<ReferralActivityChartProps> = ({ chartData }) => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-medium mb-4">Referral Activity</h3>
      <div className="h-80">
        <ChartContainer
          config={{
            sent: { color: "#93c5fd" },
            approved: { color: "#4ade80" }
          }}
        >
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="sent" fill="#93c5fd" name="Sent" />
            <Bar dataKey="approved" fill="#4ade80" name="Approved" />
          </BarChart>
        </ChartContainer>
      </div>
    </Card>
  );
};

export default ReferralActivityChart;
